"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductSelectWithSearch = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _Popup = require("../Popup");
var _searchQuestion = _interopRequireDefault(require("../../assets/images/search-question.svg"));
var _ProductList = require("../ProductList/ProductList");
var _ProductList2 = require("../ProductList");
var _Message = require("../Message");
var _types = require("../../types");
var _getPrefixCls = require("../../utils/getPrefixCls");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var defaultTabTitleColor = '#212121';
var ProductSelectWithSearch = function ProductSelectWithSearch(props) {
  var _buttonGroup$buttons;
  var popupTitle = props.popupTitle,
    tabTitles = props.tabTitles,
    selectOrderText = props.selectOrderText,
    defaultSelected = props.defaultSelected,
    searchPlaceholder = props.searchPlaceholder,
    itemText = props.itemText,
    itemsText = props.itemsText,
    showOrderId = props.showOrderId,
    showLoading = props.showLoading,
    productOrOrderEmptyText = props.productOrOrderEmptyText,
    pageSize = props.pageSize,
    _props$noMoreText = props.noMoreText,
    noMoreText = _props$noMoreText === void 0 ? '' : _props$noMoreText,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
    _props$onLoadMore = props.onLoadMore,
    onLoadMore = _props$onLoadMore === void 0 ? function () {
      return Promise.resolve({
        data: []
      });
    } : _props$onLoadMore,
    _props$showSearch = props.showSearch,
    showSearch = _props$showSearch === void 0 ? false : _props$showSearch,
    _props$content = props.content,
    content = _props$content === void 0 ? '' : _props$content,
    buttonGroup = props.buttonGroup;
  var prefixCls = (0, _getPrefixCls.getPrefixCls)('product-select-with-search');
  var _React$useState = _react.default.useState(true),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    popupVisible = _React$useState2[0],
    setPopupVisible = _React$useState2[1];
  var handleClosePopup = function handleClosePopup() {
    onClose();
    setPopupVisible(false);
  };
  var buttons = (buttonGroup === null || buttonGroup === void 0 ? void 0 : (_buttonGroup$buttons = buttonGroup.buttons) === null || _buttonGroup$buttons === void 0 ? void 0 : _buttonGroup$buttons.map(function (button) {
    var _button$action, _button$action2;
    if ((button === null || button === void 0 ? void 0 : (_button$action = button.action) === null || _button$action === void 0 ? void 0 : _button$action.func) === _types.ButtonEvents.popupSelectOrder || (button === null || button === void 0 ? void 0 : (_button$action2 = button.action) === null || _button$action2 === void 0 ? void 0 : _button$action2.func) === _types.ButtonEvents.popupSelectProduct) {
      button.onClick = function () {
        setPopupVisible(true);
      };
    }
    return button;
  })) || [];
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Message.Message, {
    content: content,
    buttonGroup: _objectSpread(_objectSpread({}, buttonGroup), {}, {
      buttons: buttons
    })
  }), /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    title: popupTitle,
    titleClassName: "".concat(prefixCls, "-popup-title"),
    contentClassName: "".concat(prefixCls, "-popup-content"),
    active: popupVisible,
    maskClosable: false,
    showCloseIcon: true,
    onClose: handleClosePopup
  }, /*#__PURE__*/_react.default.createElement("div", null, showSearch && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-input")
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "".concat(prefixCls, "-input-content"),
    placeholder: searchPlaceholder
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _searchQuestion.default,
    alt: "search",
    className: "".concat(prefixCls, "-input-icon")
  })), /*#__PURE__*/_react.default.createElement("div", null, (tabTitles === null || tabTitles === void 0 ? void 0 : tabTitles.length) === 0 ? /*#__PURE__*/_react.default.createElement(_ProductList.ProductList, {
    type: 0,
    onLoadMore: onLoadMore,
    selectOrderText: selectOrderText,
    itemText: itemText,
    itemsText: itemsText,
    showOrderId: showOrderId,
    limit: pageSize,
    onButtonClick: handleClosePopup,
    showLoading: showLoading,
    isProductCardNew: true,
    productOrOrderEmptyText: productOrOrderEmptyText,
    noMoreText: noMoreText,
    isUIOptimisation: true
  }) : /*#__PURE__*/_react.default.createElement(_ProductList2.ProductListTabs, {
    tabs: tabTitles,
    defaultSelected: defaultSelected,
    defaultTabTitleColor: defaultTabTitleColor,
    type: _ProductList2.TabsType.underscore,
    onLoadMore: onLoadMore,
    selectOrderText: selectOrderText,
    itemText: itemText,
    itemsText: itemsText,
    onButtonClick: handleClosePopup,
    showOrderId: showOrderId,
    showLoading: showLoading,
    productOrOrderEmptyText: productOrOrderEmptyText,
    noMoreText: noMoreText,
    isUIOptimisation: true
  })))));
};
exports.ProductSelectWithSearch = ProductSelectWithSearch;